





























































import Vue, { PropType } from 'vue'
import XIcon, { IconProps } from '../Icon/XIcon.vue'

export default Vue.extend({
  inheritAttrs: false,
  name: 'XInput',
  components: { XIcon },
  props: {
    label: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    rules: {
      type: [String, Object],
      required: false,
    },
    exClasses: {
      type: String,
      required: false,
    },
    prependIcon: {
      type: Object as PropType<IconProps>,
      required: false,
    },
    appendIcon: {
      type: Object as PropType<IconProps>,
      required: false,
    },
  },
  watch: {
    error(message) {
      if (!message) {
        return
      }
      const { validationProvider } = this.$refs as any
      validationProvider.applyResult({
        errors: [message],
        valid: false,
        failedRules: {},
      })
    },
  },
})
